/**
 * Values for {@code ReportLicence|...} clauses in the CME TelSys list {@code filter} query param (case-insensitive on the server).
 */
export const TELSYS_LIST_LICENSE_CATEGORY_TOKEN = {
    HISTORIC_ONLY: 'historicOnly',
    STANDARD: 'standard',
    ENTERPRISE: 'enterprise',
    ACD: 'acd',
    NONE: 'none',
    MIXED: 'mixed',
    UNKNOWN: 'unknown'
} as const

export type TelsysListLicenseCategoryToken =
    (typeof TELSYS_LIST_LICENSE_CATEGORY_TOKEN)[keyof typeof TELSYS_LIST_LICENSE_CATEGORY_TOKEN]

/**
 * Keys in {@code TelsysListLanguage} bundles for list filter labels.
 */
export const TELSYS_LIST_LANGUAGE_KEYS = {
    FILTER_PLATFORM_TYPE: 'TelsysList_Filter_PlatformType',
    FILTER_REPORT_LICENCE: 'TelsysList_Filter_ReportLicence',
    FILTER_MODULE_STATUS: 'TelsysList_Filter_ModuleStatus',
    LICENCE_HISTORIC_ONLY: 'TelsysList_LicenceFilter_HistoricOnly',
    LICENCE_STANDARD: 'TelsysList_LicenceFilter_Standard',
    LICENCE_ENTERPRISE: 'TelsysList_LicenceFilter_Enterprise',
    LICENCE_ACD: 'TelsysList_LicenceFilter_Acd',
    LICENCE_NONE: 'TelsysList_LicenceFilter_None',
    LICENCE_MIXED: 'TelsysList_LicenceFilter_Mixed',
    LICENCE_UNKNOWN: 'TelsysList_LicenceFilter_Unknown'
} as const

export const TELSYS_MODULE_STATUS_CODE = {
    UNKNOWN: -1,
    JUST_STARTING_OR_CLOSED_DOWN: 0,
    STOPPED: 1,
    STARTING: 2,
    ENDING: 3,
    DISABLED: 4,
    RUNNING_COMMS_INACTIVE: 5,
    RUNNING_COMMS_UNLICENSED: 6,
    RUNNING_COMMS_STARTING_CORE: 7,
    RUNNING_COMMS_STARTING_DEVICE_MONITORING: 8,
    RUNNING_COMMS_STOPPING: 9,
    RUNNING_COMMS_OK: 10,
    RUNNING_COMMS_OK_WARNINGS: 11,
    RUNNING_COMMS_OK_SYNCHRONISING: 12,
    RUNNING_COMMS_OK_SYNCHRONISED: 13,
    RUNNING_COMMS_OK_SYNCHRONISED_WARNINGS: 14,
    RUNNING_COMMS_OK_SYNCHRONISE_FAILED: 15,
    RUNNING_COMMS_OK_NOT_IN_SERVICE: 16,
    DISABLED_COMMS_ENDED_UNGRACEFULLY: 17,
    RUNNING_COMMS_OK_SYNCHRONISATION_FAILED: 18,
    RUNNING_COMMS_OK_BOTS_DISABLED: 19,
    RUNNING_COMMS_OK_BOTS_DISABLED_WARNINGS: 20,
    RUNNING_COMMS_INACTIVE_INCORRECT_PERMISSION: 21
} as const
